<template>
	<compact-banner
		:gradient-colors="{ primary: '#0a0a0a', secondary: '#2d1b3d', tertiary: '#1a1a1a' }"
		:grid-color="'#555'"
		css-class="master-classes-promo-banner"
	>
		<div class="master-classes-content">
			<div class="master-classes-text-section">
				<h2 class="master-classes-title">RunDiffusion Open-Source Apps <br>Master Classes</h2>
				<p class="master-classes-subtitle">Join the Next Generation of AI Artists</p>
			</div>

			<div class="master-classes-features-section">
				<div class="master-classes-features">
					<div class="feature-item">
						<div class="feature-bullet"></div>
						<span><b>100% FREE</b> for limited time</span>
					</div>
					<div class="feature-item">
						<div class="feature-bullet"></div>
						<span><b>(1)</b> A Novice's Guide to Stable Diffusion, <b>(2)</b> Introduction to Stable Diffusion, <b>(3)</b> Foundations of Stable Diffusion</span>
					</div>
					<div class="feature-item">
						<div class="feature-bullet"></div>
						<span>Hands-on Challenges</span>
					</div>
				</div>
			</div>

			<div class="master-classes-cta-section">
				<base-button
					:css-class="{ 'master-classes-cta-button': true }"
					@click="handleClick"
				>
					Access FREE Course
				</base-button>
			</div>
		</div>
	</compact-banner>
</template>

<script>
import CompactBanner from '@/components/PromoBanners/CompactBanner.vue'
import BaseButton from '@/components/base/BaseButton.vue'

export default {
	name: 'MasterClassesPromoBanner',
	components: {
		CompactBanner,
		BaseButton
	},
	methods: {
		handleClick() {
			window.open('https://www.rundiffusion.com/open-source-masterclass', '_blank', 'noopener,noreferrer');
		}
	}
}
</script>

<style lang="scss" scoped>
.master-classes-promo-banner {
	.master-classes-content {
		display: flex;
		width: 100%;
		height: 100%;
		align-items: stretch;
		gap: 20px;

		// Mobile: stack vertically with proper spacing
		@media (max-width: 959px) {
			flex-direction: column;
			gap: 15px;
			align-items: flex-start;
			justify-content: flex-start;
			padding-right: 160px; // Make room for absolute positioned button
		}
	}

	.master-classes-text-section {
		flex: 0 0 33.33%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		z-index: 20;

		@media (max-width: 959px) {
			flex: none;
			width: 100%;
		}

		.master-classes-title {
			font-size: 20px;
			font-weight: bold;
			color: white;
			margin: 0 0 4px 0;
			line-height: 1.1;

			@media (max-width: 959px) {
				font-size: 18px;
			}
		}

		.master-classes-subtitle {
			color: #bbb;
			margin: 0;
			font-size: 14px;

			@media (max-width: 959px) {
				font-size: 13px;
			}
		}
	}

	.master-classes-features-section {
		flex: 0 0 33.33%;
		display: flex;
		align-items: center;
		z-index: 20;

		@media (max-width: 959px) {
			flex: none;
			width: 100%;
		}

		.master-classes-features {
			display: flex;
			flex-direction: column;
			gap: 8px;
			width: 100%;

			// Decrease spacing on mobile
			@media (max-width: 959px) {
				gap: 4px;
			}

			.feature-item {
				display: flex;
				align-items: center;
				gap: 10px;
				color: white;
				font-size: 12px;

				.feature-bullet {
					width: 6px;
					height: 6px;
					border-radius: 50%;
					background-color: rgb(160, 170, 236);
					flex-shrink: 0;
				}
			}
		}
	}

	.master-classes-cta-section {
		flex: 0 0 33.33%;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 20;

		@media (max-width: 959px) {
			flex: none;
			width: auto;
			position: absolute;
			right: 35px;
			top: 50%;
		}

	}
}
</style>
